// FOR THE SPINNER FOR BUTTON LOADING

import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import PropTypes from 'prop-types';
import './SpinnerWithLoader.module.css';

const SpinnerWithLoader = ({ spinnerType = "border", size = "sm", text = "" }) => {
    return (
        <div className="spinner-container">
            <Spinner
                as="span"
                animation={spinnerType}
                size={size}
                role="status"
                aria-hidden="true"
                style={{ color: '#9CA3AF' }}
            />
            <span className="visually-hidden">{text}</span>
            {text}
        </div>
    );
};

// Defining PropTypes for the component
SpinnerWithLoader.propTypes = {
    spinnerType: PropTypes.oneOf(["border", "grow"]),
    size: PropTypes.oneOf(["sm", "lg"]),
    text: PropTypes.string,
};

export default SpinnerWithLoader;
